import { __awaiter, __generator, __read, __spread } from "tslib";
import { getOnlyFulfilled, waitForAllPromises, waitForFirstFulfilledPromise, } from './promise-helpers';
var flatten = function (arr) {
    var _a;
    return (_a = []).concat.apply(_a, __spread(arr));
};
/**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */
export default (function (providers) {
    if (providers.length === 0) {
        throw new Error('At least one provider must be provided');
    }
    var getFulfilledProviders = function () { return __awaiter(void 0, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, waitForAllPromises(providers.map(function (result) { return Promise.resolve(result); }))];
                case 1:
                    results = _a.sent();
                    return [2 /*return*/, getOnlyFulfilled(results)];
            }
        });
    }); };
    var runInAllProviders = function (mapFunction) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFulfilledProviders()];
                case 1: return [2 /*return*/, (_a.sent()).map(function (provider) {
                        return mapFunction(provider);
                    })];
            }
        });
    }); };
    var createCallback = function (methodName, args) { return function (provider) {
        var method = provider[methodName];
        if (typeof method === 'function') {
            return method.apply(provider, args);
        }
        throw new Error("\"" + methodName + "\" isn't a function of the provider");
    }; };
    /**
     * Run a method from the provider which expects to return a single item
     * @param methodName
     * @param args
     */
    var invokeSingle = function (methodName, args) { return __awaiter(void 0, void 0, void 0, function () {
        var callback, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    callback = createCallback(methodName, args);
                    _a = waitForFirstFulfilledPromise;
                    return [4 /*yield*/, runInAllProviders(callback)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    }); };
    /**
     * Run a method in the provider which expectes to return a list of items
     * @param methodName
     * @param args
     */
    var invokeList = function (methodName, args) { return __awaiter(void 0, void 0, void 0, function () {
        var callback, results, _a, fulfilledResults;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    callback = createCallback(methodName, args);
                    _a = waitForAllPromises;
                    return [4 /*yield*/, runInAllProviders(callback)];
                case 1: return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
                case 2:
                    results = _b.sent();
                    fulfilledResults = getOnlyFulfilled(results);
                    return [2 /*return*/, flatten(fulfilledResults).filter(function (result) { return result; })];
            }
        });
    }); };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList,
    };
});
//# sourceMappingURL=combine-providers.js.map